import { useState, useMemo } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Dropdown from "../../../share/components/dropdown";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import countryList from "../../../dataFiles/country";
import FormHelperText from "@mui/material/FormHelperText";
import { ZustandStore } from "../../../../store/zustand-store";
import axios from "axios";
import {
  GET_SAVELINKFEATURE_API,
  POST_LINKFEATURE_API,
} from "../../../../Adsy/services/api";
import AdsyStore from "../../../../Adsy/store/AdsyStore";

function BacklinkBuyNowDialog({ open, onClose }) {
  const { user_profile } = ZustandStore((state) => state);
  const [country, setCountry] = useState({
    name: "United States",
    value: 2840,
    flag: "https://flagsapi.com/US/flat/24.png",
  });
  const [companyName, setCompanyName] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [website, setWebsite] = useState("");
  const [Error, setError] = useState({
    msg: "",
    type: "",
  });

  const country_data = useMemo(() => {
    return countryList?.map((country) => {
      return {
        location_code: country.location_code,
        location_name: country.location_name,
        location_flag: country.location_flag,
      };
    });
  }, [countryList]);

  const countryDetailHandler = (res) => {
    setCountry({
      name: res.location_name,
      value: res.location_code,
      flag: res.location_flag,
    });
  };

  const handlePhoneNumber = (e) => {
    if (Error.type === "mobile") {
      setError({
        type: "",
        msg: "",
      });
    }
    setMobileNo(e);
  };

  const getLinkFeature = async () => {
    try {
      const resp2 = await axios.get(
        GET_SAVELINKFEATURE_API(user_profile.email)
      );

      AdsyStore.setState((state) => ({
        get_link_feature: {
          ...state.get_link_feature,
          save_links: resp2.data,
        },
      }));
    } catch (error) {
      AdsyStore.setState((state) => ({
        get_link_feature: {
          ...state.get_link_feature,
          save_links: [],
        },
      }));
    }
  };
  
  const handleSubmitBuyLink = async () => {
    const company =
      user_profile.company_name === "0"
        ? companyName
        : user_profile.company_name;
    const phoneRegex = /^\+\d{1,3}\s?\d{6,14}$/; // Matches +[country code] followed by number
    if (!mobileNo) {
      setError({
        msg: "Please enter Phone Number",
        type: "mobile",
      });
      return false;
    } else if (!phoneRegex.test(mobileNo)) {
      setError({
        msg: "Invalid phone number",
        type: "mobile",
      });
      return false;
    }
    if (!company) {
      setError({
        msg: "Please enter company name",
        type: "companyname",
      });
      return;
    }
    if (!website) {
      setError({
        msg: "Please enter website",
        type: "website",
      });
      return;
    }

    const data = [
      {
        URL: open.URL || "NO URL",
        DA: open.DA || 0,
        DR: open.DR || 0,
        Niche: open.Niche || "",
        Cost: open.Cost || 0,
        Traffic: open.Traffic || 0,
        Status: open.Status || "",
      },
    ];

    try {
      const payload = {
        email: user_profile.email,
        name: user_profile.name,
        company_name: company,
        country:
          user_profile.country === "0" ? country.name : user_profile.country,
        budget: "0",
        website,
        phone: mobileNo,
        data: data,
      };
      const resp = await axios.post(POST_LINKFEATURE_API(), payload);
      if (resp.data.status === 200) {
        getLinkFeature();
        onClose();
      }
    } catch (error) {
      setError({
        msg: "Link Save Failed",
        type: "API",
      });
    }
  };

  return (
    <Dialog
      open={Boolean(open)}
      onClose={onClose}
      aria-labelledby="buy-now-dialog"
      aria-describedby="buy-now-dialog-description"
      fullWidth={true}
      maxWidth={"sm"}
      sx={{
        "& .MuiPaper-root": { overflowY: "visible", minHeight: "400px" },
        "& .MuiDialogContent-root": { overflowY: "visible" },
      }}
    >
      <DialogTitle id="buy-now-dialog">I'm Interested</DialogTitle>

      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <DialogContentText id="buy-now-dialog-description">
          <Box>
            <Box className="row">
              <Box className="col-md-6">
                <Box className="mb-2">
                  <label htmlFor="name" className="form-label">
                    Name
                  </label>
                  <TextField
                    className="filter-input-control"
                    id="name"
                    variant="outlined"
                    size="small"
                    fullWidth
                    disabled
                    value={user_profile?.name}
                  />
                </Box>
              </Box>

              <Box className="col-md-6">
                <Box className="mb-2">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <TextField
                    type="email"
                    className="filter-input-control"
                    id="email"
                    variant="outlined"
                    size="small"
                    fullWidth
                    disabled
                    value={user_profile.email}
                  />
                </Box>
              </Box>

              <Box className="col-md-6">
                <Box className="mb-2">
                  <label htmlFor="country" className="form-label">
                    Country
                  </label>
                  {user_profile?.company_name === "0" ? (
                    <Dropdown
                      img={country.flag}
                      data={country_data}
                      title={country.name}
                      style={{
                        textTransform: "none",
                        boxShadow: "none",
                        border: "1px solid rgba(0, 0, 0, 0.23)",
                        padding: "0.65rem",
                        height: "40px",
                        width: "100%",
                      }}
                      callback={countryDetailHandler}
                    />
                  ) : (
                    <TextField
                      className="filter-input-control"
                      id="country"
                      variant="outlined"
                      size="small"
                      fullWidth
                      disabled
                      value={user_profile?.company_name}
                    />
                  )}
                </Box>
              </Box>

              <Box className="col-md-6">
                <Box className="mb-2">
                  <label htmlFor="mobile" className="form-label">
                    Phone number
                  </label>

                  <PhoneInput
                    international
                    defaultCountry="US"
                    countryCallingCodeEditable={false}
                    placeholder="Enter phone number"
                    value={mobileNo}
                    onChange={handlePhoneNumber}
                    className="buylink-phone-input"
                  />
                  {Error.type === "mobile" && (
                    <FormHelperText
                      id="outlined-weight-helper-text"
                      sx={{ color: "red" }}
                    >
                      {Error.msg}
                    </FormHelperText>
                  )}
                </Box>
              </Box>

              <Box className="col-md-6">
                <Box className="mb-2">
                  <label htmlFor="companyname" className="form-label">
                    Company
                  </label>

                  <TextField
                    className="filter-input-control"
                    id="companyname"
                    variant="outlined"
                    size="small"
                    placeholder="Enter Company Name"
                    fullWidth
                    disabled={!user_profile.company_name === "0"}
                    value={
                      user_profile?.company_name === "0"
                        ? companyName
                        : user_profile.company_name
                    }
                    onChange={(e) => {
                      if (Error.type === "companyname") {
                        setError({
                          type: "",
                          msg: "",
                        });
                      }
                      setCompanyName(e.target.value);
                    }}
                  />
                  {Error.type === "companyname" && (
                    <FormHelperText
                      id="outlined-weight-helper-text"
                      sx={{ color: "red" }}
                    >
                      {Error.msg}
                    </FormHelperText>
                  )}
                </Box>
              </Box>
              <Box className="col-md-6">
                <Box className="mb-2">
                  <label htmlFor="website" className="form-label">
                    Website
                  </label>

                  <TextField
                    className="filter-input-control"
                    id="website"
                    variant="outlined"
                    size="small"
                    placeholder="Enter your website"
                    fullWidth
                    value={website}
                    onChange={(e) => {
                      if (Error.type === "website") {
                        setError({
                          type: "",
                          msg: "",
                        });
                      }
                      setWebsite(e.target.value);
                    }}
                  />
                  {Error.type === "website" && (
                    <FormHelperText
                      id="outlined-weight-helper-text"
                      sx={{ color: "red" }}
                    >
                      {Error.msg}
                    </FormHelperText>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </DialogContentText>
        {Error.type === "API" && (
          <FormHelperText
            id="outlined-weight-helper-text"
            sx={{ color: "red" }}
          >
            {Error.msg}
          </FormHelperText>
        )}
      </DialogContent>
      <DialogActions sx={{ padding: "0px 15px 15px 15px" }}>
        <Button
          onClick={handleSubmitBuyLink}
          className="blue-btn transform-off"
          variant="contained"
          size="large"
        >
          Submit
        </Button>
        <div></div>
      </DialogActions>
    </Dialog>
  );
}

export default BacklinkBuyNowDialog;
